import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	timeRange: {
		id: 'eoc-schedule-common.utils.shift.time-range',
		defaultMessage: 'From {start} to {end}',
		description:
			'Time range label. Ex. From Oct 31 12:18 AM to Later than the current period, or any other range.',
	},
});
